export enum CampaignTypes {
  RAFFLE = 'RAFFLE',
  STANDARD = 'STANDARD'
}

export enum CampaignRaffleStatus {
  NOT = 'NOT_ASSIGNED',
  PENDING = 'PENDING_VALIDATION_OF_ASSIGNMENT',
  ASSIGNED = 'ASSIGNED',
  DECLINED = 'DECLINED'
}
